import { createAction, props } from '@ngrx/store';

import {
  PowerPage,
  PowerPageBlock,
  PowerPageBlockSavePayload,
  PowerPageDetail,
  PowerPageManageOptions,
  PowerPageSavePayload,
  PowerPagesListMeta,
  PowerPagesListParams,
} from '../models/power-page.model';

export const loadPowerPages = createAction(
  '[Power Pages] Load Power Pages',
  props<PowerPagesListParams>()
);

export const loadPowerPagesSuccess = createAction(
  '[Power Pages] Load Power Pages Success',
  props<{ powerPages: PowerPage[]; meta: PowerPagesListMeta }>()
);

export const loadPowerPagesFailure = createAction(
  '[Power Pages] Load Power Pages Failure',
  props<{ error: string }>()
);

export const deletePowerPage = createAction(
  '[Power Pages] Delete Power Page',
  props<{ uuid: string }>()
);

export const deletePowerPageSuccess = createAction('[Power Pages] Delete Power Page Success');

export const duplicatePowerPage = createAction(
  '[Power Pages] Duplicate Power Page',
  props<{ uuid: string }>()
);

export const duplicatePowerPageSuccess = createAction('[Power Pages] Duplicate Power Page Success');

export const mutationFailure = createAction(
  '[Power Pages] Mutation Failure',
  props<{ error: string }>()
);

export const resetPowerPagesState = createAction('[Power Pages] Reset State');

/* -------------------------------------------------------------------------- */
/* Editor: options, single load, save                                          */
/* -------------------------------------------------------------------------- */

export const loadPowerPageOptions = createAction('[Power Pages] Load Options');

export const loadPowerPageOptionsSuccess = createAction(
  '[Power Pages] Load Options Success',
  props<{ options: PowerPageManageOptions }>()
);

export const loadPowerPageOptionsFailure = createAction(
  '[Power Pages] Load Options Failure',
  props<{ error: string }>()
);

export const loadPowerPage = createAction(
  '[Power Pages] Load Power Page',
  props<{ uuid: string }>()
);

export const loadPowerPageSuccess = createAction(
  '[Power Pages] Load Power Page Success',
  props<{ powerPage: PowerPageDetail }>()
);

export const loadPowerPageFailure = createAction(
  '[Power Pages] Load Power Page Failure',
  props<{ error: string }>()
);

export const savePowerPage = createAction(
  '[Power Pages] Save Power Page',
  props<{ uuid?: string; payload: PowerPageSavePayload }>()
);

export const savePowerPageSuccess = createAction(
  '[Power Pages] Save Power Page Success',
  props<{ powerPage: PowerPageDetail }>()
);

export const savePowerPageFailure = createAction(
  '[Power Pages] Save Power Page Failure',
  props<{ error: string }>()
);

export const resetPowerPageEditor = createAction('[Power Pages] Reset Editor');

/* -------------------------------------------------------------------------- */
/* Content blocks                                                              */
/* -------------------------------------------------------------------------- */

export const loadBlocks = createAction(
  '[Power Pages] Load Blocks',
  props<{ powerPageUuid: string }>()
);

export const loadBlocksSuccess = createAction(
  '[Power Pages] Load Blocks Success',
  props<{ blocks: PowerPageBlock[] }>()
);

export const loadBlocksFailure = createAction(
  '[Power Pages] Load Blocks Failure',
  props<{ error: string }>()
);

export const createBlock = createAction(
  '[Power Pages] Create Block',
  props<{ powerPageUuid: string; payload: PowerPageBlockSavePayload }>()
);

export const editBlock = createAction(
  '[Power Pages] Edit Block',
  props<{ blockUuid: string; powerPageUuid: string; payload: PowerPageBlockSavePayload }>()
);

export const saveBlockSuccess = createAction(
  '[Power Pages] Save Block Success',
  props<{ block: PowerPageBlock; powerPageUuid: string }>()
);

export const saveBlockFailure = createAction(
  '[Power Pages] Save Block Failure',
  props<{ error: string }>()
);

export const deleteBlock = createAction(
  '[Power Pages] Delete Block',
  props<{ blockUuid: string; powerPageUuid: string }>()
);

export const deleteBlockSuccess = createAction('[Power Pages] Delete Block Success');

export const deleteBlockFailure = createAction(
  '[Power Pages] Delete Block Failure',
  props<{ error: string }>()
);

export const resetBlocks = createAction('[Power Pages] Reset Blocks');
